import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Divider,
} from '@material-ui/core';

import { BaseTextField, BaseButton } from 'views/UIWidgets';
import { setCurrentUser } from 'actions';
import { COOKIE_NAME } from 'utils/constants';

const Password = props => {
	const {
		className,
		setCurrentUser,
		history,
		user,
		staticContext,
		...rest
	} = props;

	const [values, setValues] = useState({
		password: '',
		confirm: '',
		email: user?.email,
		errors: {
			email: false,
			password: false,
			confirm: false,
		},
	});

	const [updating, setUpdating] = useState(false);

	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		const updateDetail = async () => {
			axios
				.put('/api/managers', {
					email: values.email,
					password: values.password,
				})
				.then(result => {
					enqueueSnackbar('信息更新成功，请重新登陆', { variant: 'success' });

					setCurrentUser(null);

					// Clear Cookie
					document.cookie =
						COOKIE_NAME + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

					setTimeout(() => {
						history.push('/sign-in');
					}, 2);
				})
				.catch(error => {
					console.log(error);
					enqueueSnackbar('error', { variant: 'error' });
				});
		};

		if (updating) updateDetail();
	}, [updating, enqueueSnackbar, history, setCurrentUser, values]);

	const handleChange = event => {
		setValues({
			...values,
			[event.target.name]: event.target.value,
			errors: {
				...values.errors,
				[event.target.name]: false,
				notMatch: false,
			},
		});
	};

	const handleClick = () => {
		const { password, confirm, email } = values;
		let error = {};
		if (!email) error['email'] = true;
		if (!password) error['password'] = true;
		if (!confirm) error['confirm'] = true;
		if (password !== confirm) error['notMatch'] = true;

		if (Object.keys(error).length > 0) {
			return setValues({
				...values,
				errors: { ...values.errors, ...error },
			});
		}

		setUpdating(true);
	};

	const hasError = field => (values.errors[field] ? true : false);

	return (
		<Card {...rest}>
			<form>
				<CardHeader subheader='更改管理员账户和密码' title='账户和密码' />
				<Divider />
				<CardContent>
					<BaseTextField
						title='Email'
						name='email'
						error={hasError('email')}
						onChange={handleChange}
						type='email'
						value={values.email}
					/>
					<BaseTextField
						title='Password'
						name='password'
						error={hasError('password') || hasError('notMatch')}
						onChange={handleChange}
						style={{ marginTop: '1rem' }}
						type='password'
						value={values.password}
					/>
					<BaseTextField
						title='Confirm password'
						name='confirm'
						error={hasError('confirm') || hasError('notMatch')}
						onChange={handleChange}
						style={{ marginTop: '1rem' }}
						type='password'
						value={values.confirm}
					/>
				</CardContent>
				<Divider />
				<CardActions>
					<BaseButton
						title='确定'
						color='primary'
						onClick={handleClick}
						isLoading={updating}
					/>
				</CardActions>
			</form>
		</Card>
	);
};

Password.propTypes = {
	className: PropTypes.string,
};

const mapStateToProps = state => {
	return { user: state.auth && state.auth.user };
};

export default connect(mapStateToProps, { setCurrentUser })(
	withRouter(Password)
);
